import { type Block } from '@basehub/data/replicache/index'
import { isBlockWithChildren } from '@basehub/data/replicache/index'

export function blockIsFavorite({
  block,
  favoriteBlocks,
}: {
  block: Block
  favoriteBlocks: string[]
}) {
  return (
    isBlockWithChildren(block) &&
    favoriteBlocks.some(
      (favId) => favId === block.id || favId === block.sourceBlockId
    )
  )
}
